export default __webpack_public_path__ + "static/sprue-4f8494184094242a6ac9fc9e99e887e2.png";